import Leverup from '@ui/services/contract/abis/Leverup';
import LpManagerFacet from '@ui/services/contract/abis/LpManagerFacet';
import PriceFacadeFacet from '@ui/services/contract/abis/PriceFacadeFacet';
import TradingCloseFacet from '@ui/services/contract/abis/TradingCloseFacet';
import TradingConfigFacet from '@ui/services/contract/abis/TradingConfigFacet';
import TradingCoreFacet from '@ui/services/contract/abis/TradingCoreFacet';
import TradingPortalFacet from '@ui/services/contract/abis/TradingPortalFacet';
import VaultFacet from '@ui/services/contract/abis/VaultFacet';
import type { Abi } from 'viem';
import { decodeErrorResult } from 'viem';

const CUSTOM_ERROR_ABIS: Abi[] = [
  Leverup as Abi,
  TradingPortalFacet as Abi,
  TradingCoreFacet as Abi,
  TradingConfigFacet as Abi,
  TradingCloseFacet as Abi,
  PriceFacadeFacet as Abi,
  LpManagerFacet as Abi,
  VaultFacet as Abi,
];

export const parseCustomErrorReason = (
  reason?: string | null,
): string | null => {
  if (!reason || typeof reason !== 'string' || !reason.startsWith('0x')) {
    return null;
  }

  for (const abi of CUSTOM_ERROR_ABIS) {
    try {
      const decoded = decodeErrorResult({
        abi,
        data: reason as `0x${string}`,
      });

      if (!decoded?.errorName) continue;

      const formattedArgs = formatArgs(decoded.args);

      return formattedArgs
        ? `${decoded.errorName}(${formattedArgs})`
        : decoded.errorName;
    } catch {
      // Ignore and try next ABI
    }
  }

  return null;
};

const formatArgs = (args?: readonly unknown[]) => {
  if (!args || args.length === 0) return '';

  return args
    .map((arg) => formatArgValue(arg))
    .filter((value) => value.length > 0)
    .join(', ');
};

const formatArgValue = (value: unknown): string => {
  if (typeof value === 'bigint') {
    return value.toString();
  }

  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  ) {
    return String(value);
  }

  if (Array.isArray(value)) {
    return `[${value.map((item) => formatArgValue(item)).join(', ')}]`;
  }

  if (value && typeof value === 'object') {
    return `{${Object.entries(value)
      .filter(([key]) => Number.isNaN(Number(key)))
      .map(([key, val]) => `${key}: ${formatArgValue(val)}`)
      .join(', ')}}`;
  }

  return '';
};

